import { addDays, format } from "date-fns";
import fetchStatus from "../api/fetch-status";
import Auth from "../../services/auth";
import { getBaseUrl } from "../url";

const mergeHeaders = (headers) => {
    let tz;
    try {
        tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (e) {
        //
    }
    return {
        ...(Auth.token &&
            Auth.token.access_token && {
                authorization: `Bearer ${Auth.token && Auth.token.access_token}`,
            }),
        ...(tz && { tz }),
        ...headers,
    };
};

const getMergedHeaders = (opts, headers) => {
    if (!opts || !opts.body || !(opts.body instanceof FormData)) {
        return mergeHeaders({ "Content-Type": "application/json", ...headers });
    }
    return mergeHeaders(headers);
};
const useAbortableStreamFetch = async (
    streamURL,
    state,
    controller,
    setState,
    fromDate,
    toDate,
    options,
    queryParams
) => {
    try {
        let finalUrl = `${getBaseUrl()}${streamURL.startsWith("/") ? streamURL : `/${streamURL}`}`;
        if (fromDate) {
            finalUrl += `?from=${format(fromDate, "yyyy-MM-dd")}&to=${format(
                addDays(toDate, 1),
                "yyyy-MM-dd"
            )}`;
        }

        if (queryParams) {
            if (fromDate) {
                finalUrl += `&${queryParams}`;
            } else {
                finalUrl += `?${queryParams}`;
            }
        }
        setState((prevState) => {
            return {
                ...prevState,
                status: fetchStatus.STREAMING,
                errorCode: null,
            };
        });

        const resp = await fetch(finalUrl, {
            signal: controller && controller.signal,
            compress: false,
            decompress: true,
            credentials: "same-origin",
            method: (options && options.method) || "GET",
            body: options && options.body,
            headers: {
                ...getMergedHeaders(undefined, {
                    "Content-Type": "application/json",
                    "Transfer-Encoding": "chunked",
                    "Content-Encoding": "identity",
                    "Accept-Encoding": "identity",
                    duplex: "half",
                }),
            },
        });

        if (!resp.ok || !resp.body) {
            throw resp.statusText;
        }

        const reader = resp.body.getReader();
        // eslint-disable-next-line no-constant-condition
        while (true) {
            // eslint-disable-next-line no-await-in-loop
            const { value, done } = await reader.read();
            if (done) {
                setState((prevState) => {
                    try {
                        if (prevState.string.includes("<ERROR>Request Failed</ERROR>")) {
                            return {
                                ...prevState,
                                status: fetchStatus.ERROR,
                                errorCode: "Request Failed",
                                controller: null,
                            };
                        }
                        let finalData;
                        if (prevState.string[prevState.string.length - 1] === ",") {
                            finalData = {
                                ...JSON.parse(
                                    `${prevState.string.substring(0, prevState.string.length - 1)}}`
                                ),
                            };
                        } else if (prevState.string[prevState.string.length - 2] === ",") {
                            finalData = {
                                ...JSON.parse(
                                    `${prevState.string.substring(0, prevState.string.length - 2)}}`
                                ),
                            };
                        } else {
                            finalData = JSON.parse(prevState.string);
                        }
                        return {
                            ...prevState,
                            status: fetchStatus.SUCCESS,
                            data: finalData,
                            controller: null,
                        };
                    } catch (e) {
                        return {
                            ...prevState,
                            status: fetchStatus.ERROR,
                            errorCode: "parsing",
                            controller: null,
                        };
                    }
                });
                break;
            }

            const newData = new TextDecoder().decode(value);
            if (newData !== "}") {
                if (newData.includes("<ERROR>Request Failed</ERROR>")) {
                    setState((prevState) => {
                        return {
                            ...prevState,
                            status: fetchStatus.ERROR,
                            errorCode: "Request Failed",
                            controller: null,
                        };
                    });
                    break;
                }

                try {
                    let parsedValue = "";
                    parsedValue = newData[0] === "{" ? "" : "{";
                    if (newData[newData.length - 1] === "}") {
                        if (newData[newData.length - 2] === ",") {
                            parsedValue += newData.substring(0, newData.length - 2);
                        }
                        parsedValue += "}";
                    } else if (newData[newData.length - 1] === ",") {
                        parsedValue += newData.substring(0, newData.length - 1);
                    } else {
                        parsedValue += newData;
                    }
                    parsedValue += "}";

                    setState((prevState) => {
                        try {
                            let newJSON;
                            try {
                                newJSON = {
                                    ...prevState.data,
                                    ...JSON.parse(parsedValue),
                                };
                            } catch (e) {
                                newJSON = {
                                    ...JSON.parse(prevState.string + parsedValue),
                                };
                            }
                            return {
                                ...prevState,
                                status: fetchStatus.STREAMING,
                                errorCode: null,
                                string: prevState.string + newData,
                                data: {
                                    ...newJSON,
                                },
                            };
                        } catch (e) {
                            return {
                                ...prevState,
                                status: fetchStatus.STREAMING,
                                errorCode: null,
                                string: prevState.string + newData,
                                data: {
                                    ...prevState.data,
                                },
                            };
                        }
                    });
                } catch (e) {
                    setState((prevState) => {
                        return {
                            ...prevState,
                            status: fetchStatus.ERROR,
                            errorCode: e.status,
                            controller: null,
                        };
                    });
                }
            }
        }
    } catch (err) {
        console.log(err, err.name);
        console.log(err);
        if (!err && err.name !== "AbortError") {
            setState((prevState) => ({
                ...prevState,
                status: fetchStatus.ERROR,
                data: null,
                errorCode: err && err.status,
                controller: null,
            }));
        }
    }
};

export default useAbortableStreamFetch;
